export class AppUtils {
  public static getEnumIndexes(enumInstance: any): Array<string> {
    return Object.keys(enumInstance);
  }
}
